import React from 'react'

import './AiFisio.css'

export default class Estabelecimento extends React.Component {
    render() {
        return (
            <React.Fragment>
                <div className="row assinaturas mx-auto">
                    <div className="col-5 font-weight-bold text-center bordaAssinatura">
                        Fiscal {this.props.profissao}
                            </div>
                    <div className="col-2"></div>
                    <div className="col-5 font-weight-bold text-center bordaAssinatura">
                        Profissional Responsável
                            </div>
                </div>
            </React.Fragment>
        )
    }
}